import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import "./hello_styles.scss"

const HelloCard = ({
  clickAccept,
  clickAcceptTracking,
  clickAcceptUrl,
  clickDeclineTracking,
  containerStyle,
  ctaTitle,
  declineCopy,
  logoCover,
  logoHtml,
  mainBody,
  mainTitle,
  onClickDecline,
}) => {
  const clickAcceptHandler = event => {
    if (clickAccept) {
      event.preventDefault()
      clickAccept()
    }
  }

  return (
    <div styleName={classNames("popup-container", containerStyle)}>
      <div styleName="popup-card">
        <a
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify(clickAcceptTracking)}
          href={clickAcceptUrl}
          onClick={clickAcceptHandler}
        >
          <div styleName="sla-img-container">
            <div
              styleName="logo"
              dangerouslySetInnerHTML={{ __html: logoHtml }}
            />
            {logoCover && (
              <span
                styleName="logo-cover"
                dangerouslySetInnerHTML={{ __html: logoCover }}
              />
            )}
          </div>
          <div styleName="copy">
            <h3>{mainTitle}</h3>
            <p>{mainBody}</p>
          </div>
        </a>
        <div className="action-buttons-container">
          <a
            data-track-ifttt-next-event="click"
            data-track-data={JSON.stringify(clickAcceptTracking)}
            href={clickAcceptUrl}
            onClick={clickAcceptHandler}
            className="button-tertiary"
          >
            {ctaTitle}
          </a>
          <button
            onClick={onClickDecline}
            className="button-tertiary button-cancel-link"
            data-track-ifttt-next-event="click"
            data-track-data={JSON.stringify(clickDeclineTracking)}
          >
            {declineCopy}
          </button>
        </div>
      </div>
    </div>
  )
}

HelloCard.propTypes = {
  clickAccept: PropTypes.func,
  clickAcceptTracking: PropTypes.object.isRequired,
  clickAcceptUrl: PropTypes.string,
  clickDeclineTracking: PropTypes.object.isRequired,
  containerStyle: PropTypes.string,
  ctaTitle: PropTypes.string.isRequired,
  declineCopy: PropTypes.string.isRequired,
  logoCover: PropTypes.string,
  logoHtml: PropTypes.string.isRequired,
  mainBody: PropTypes.string.isRequired,
  mainTitle: PropTypes.string.isRequired,
  onClickDecline: PropTypes.func.isRequired,
}

export default HelloCard
